module.exports = __webpack_public_path__ + "static/media/facebook-grey.ef86c3fc.svg";